// extracted by mini-css-extract-plugin
export default {"row":"styles_row__2BXR+","successTitle":"styles_successTitle__3ek-w"};